import React from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { Menu, User, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import { formatRoleLabel } from '../lib/accessRules';

function Topbar({ title, breadcrumbs = [], profile, settings, onToggleSidebar }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/');
  };

  return (
    <div className="app-topbar">
      <div className="topbar-left">
        <Button
          variant="light"
          className="sidebar-toggle-btn"
          onClick={onToggleSidebar}
        >
          <Menu size={18} />
        </Button>

        <div className="topbar-heading-wrap">
          <h1 className="page-title">{title}</h1>

          {breadcrumbs?.length > 0 && (
            <div className="breadcrumb-line">
              {breadcrumbs.map((item, index) => (
                <span key={index} className="breadcrumb-item-text">
                  {item}
                  {index < breadcrumbs.length - 1 && (
                    <span className="breadcrumb-separator">/</span>
                  )}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="topbar-right">
        <div className="topbar-welcome">
          Selamat datang, <strong>{profile?.nama_lengkap || 'Pengguna'}</strong>
        </div>

        <Dropdown align="end">
          <Dropdown.Toggle variant="light" className="profile-toggle-btn">
            <div className="profile-toggle-content">
              <div className="profile-mini-avatar">
                <User size={16} />
              </div>
              <div className="profile-mini-text">
                <div className="profile-mini-name">
                  {profile ? formatRoleLabel(profile) : 'Pengguna'}
                </div>
                <div className="profile-mini-subtext">
                  {profile?.prodi_display ||
                    profile?.prodi ||
                    settings?.nama_kampus ||
                    'Politeknik Negeri Manado'}
                </div>
              </div>
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu className="profile-dropdown-menu">
            <div className="profile-dropdown-header">
              <div className="profile-dropdown-name">
                {profile?.nama_lengkap || 'Pengguna'}
              </div>
              <div className="profile-dropdown-role">{formatRoleLabel(profile)}</div>
            </div>

            <Dropdown.Divider />

            <Dropdown.Item onClick={handleLogout} className="dropdown-logout-item">
              <LogOut size={16} className="me-2" />
              Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}

export default Topbar;
